<template>
  <div class="hk-dialog quizzes-wrapper">
    <div class="hk-dialog-wrap" ref="wrap">
      <div class="ready" v-if="isSceneReady">
        <div class="dialog-logo-wrap">
          <img v-if="course.courseType === 'LS'" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/8ff15d4d15adc8e2f7720cbae695dfba.png" alt="历史">
          <img v-else-if="course.courseType === 'DL'" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/6e296a077495759b6116213c23e5bbcf.png" alt="地理">
          <img v-else-if="course.courseType === 'SW'" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/8ff15d4d15adc8e2f7720cbae695dfba.png" alt="生物">
          <img v-else-if="course.courseType === 'SDSHK'" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/f9682497f20413140262763279fe96c1.png" alt="会考">
        </div>
        <h1>{{ quizData.title }}</h1>
        <br />
        <h2>{{ quizData.subtitle }}</h2>
        <p class="description">
          <template v-if="isLearning">{{ quizData.description }}</template>
          <template v-else>{{ quizData.description }}</template>
        </p>
        <br />
        <div v-if="exercises.length">
          <el-button
            class="btn btn-orange-square"
            @click="scene = 2">
            <template v-if="isLearning">开始学习</template>
            <template v-else-if="isExam">开始考试</template>
            <template v-else>开始练习</template>
          </el-button>
          <!--<el-button
            v-if="type === 'practice_affiliated'"
            type="danger"
          >
            其他练习
          </el-button>-->
        </div>
      </div>
      <template v-else-if="isSceneError">
        <div class="flex-wrap">
          <p class="large">{{errorInfo.message || '系统繁忙，请重试'}}</p>
          <br />
          <div>
            <div class="btn btn-blue-square" @click="onClose">退出</div>
          </div>
        </div>
      </template>
      <template v-else-if="isScenePlaying">
        <van-quizzes-controller
          ref="controller"
          :exercises="exercises"
          :is-show-explain="isShowExplain"
          :is-exam="isExam"
          :is-backtrack="!!isBacktrack"
          @exercise-change="exerciseChange"
          @result="updateResult"
          @change="change"
          @submit="examFinish"
          @end="finish" />
      </template>
      <template v-else-if="isSceneExamList">
        <van-exam-list :exercises="filterExercises.length ? filterExercises : exercises"
                       :user-answer="filterResult.length ? filterResult : results"
                       ref="examList"/>
        <van-answer-card
          v-show="isShowAnswerCard"
          class="result-answer-card"
          :score="score"
          :total="exercises.length"
          :is-exam="isExam"
          :is-learning-exam="isLearningExam"
          :is-review="isReview"
          :results="results"
          :title="quizData.title"
          :type="type"
          @again-exam="onContinue"
          @to="setAnchor"/>
      </template>
      <div class="finished" v-else>
        <div class="flex-wrap" v-if="(isReview || isWrongBook) && !isExam">
          <p class="large">你真棒！完成一组学习啦！</p>
          <br />
          <div>
            <div class="btn btn-blue-square" @click="onClose">退出</div>
          </div>
        </div>
      </div>
    </div>
    <van-footer-bar
      v-show="isScenePlaying || isSceneExamList"
      :is-exam-records="isExamRecords"
      :current-exercise="currentExercise"
      :is-exam="isExam"
      :is-show-answer-card="isShowAnswerCard"
      :total="exercises.length"
      :type="type"
      :current="exerciseIndex"
      :scene="scene"
      :results="results"
      @submit="handleSubmitExamBtn"
      @detail="detail"
      @prev="prev"
      @next="next"
      @back="examListShow"
      @toggleCheckType="handlerFilterResult" />
    <van-answer-card
      v-show="isScenePlaying && isShowAnswerCard"
      v-if="isExam"
      @to="selectExercise"
      :total="exercises.length"
      :results="results"
      :type="type"
    />
  </div>
</template>

<script>
import { Button } from 'element-ui';
import utils from '@/services/utils';
import VanQuizzesController from '@/components/quizzes/hk/new/Quizzes.vue';
import VanFooterBar from '@/components/common/FooterBar.vue';
import VanAnswerCard from '@/components/common/AnswerCard.vue';
import VanExamList from '@/components/quizzes/hk/ExamDetail.vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { SUBMIT_COURSE_RESULT, CANCEL_LAST_TIME_LEARNED } from '@/store/learning/types';
import { CURRENT_EXERCISE } from '@/store/hk/types';

const SCENE = Object.freeze({
  ready: 1,
  playing: 2,
  finished: 3,
  examList: 4,
  error: 5,
});

export default {
  props: {
    quizData: {
      type: Object,
      isRequired: true,
    },
    course: {
      type: Object,
      isRequired: true,
    },
    isExam: {
      type: Boolean,
      default: false,
    },
    isLearningExam: {
      type: Boolean,
      default: false,
    },
    isExamRecords: {
      type: Boolean,
      default: false,
    },
    examRecordScore: {
      type: Number,
      default: 0,
    },
    // 是否是易错集
    isFallible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ElButton: Button,
    VanQuizzesController,
    VanFooterBar,
    VanExamList,
    VanAnswerCard,
  },
  data() {
    return {
      scene: SCENE.ready,
      score: 0,
      results: [],
      exerciseIndex: 0,
      isShowAnswerCard: false,
      latestChange: null,
      isComplete: false,
      errorInfo: {},
      filterResult: [],
      filterExercises: [],
    };
  },
  computed: {
    ...mapGetters({
      currentExercise: CURRENT_EXERCISE,
    }),
    exercises() {
      const { quizzes } = this.quizData;
      if (quizzes && quizzes.length) {
        return quizzes.map(item => ({
          ...item,
          userAnswer: item.wrongAnswer ? JSON.parse(item.wrongAnswer) : null,
          isAgain: !!item.wrongAnswer,
        }));
      }
      return [];
    },
    answeredList() {
      return this.quizData.answeredList || [];
    },
    type() {
      return this.quizData.type;
    },
    courseId() {
      return this.$route.params.courseId || 0;
    },
    assessmentId() {
      return this.quizData.id;
    },
    isNoData() { // 不产生数据的游戏code
      return this.exercises.every(exercise => exercise.code === 'ZSD' || exercise.code === 'XT');
    },
    isBacktrack() {
      return this.quizData.isBacktrack;
    },
    isReview() {
      return this.quizData.type === 'active_review';
    },
    isLearning() { // 小节学习
      return this.quizData.type === 'learn';
    },
    isPractice() { // 小节练习
      return this.quizData.type === 'practice';
    },
    isWrongBook() {
      return this.quizData.type === 'student_wrong';
    },
    isSceneReady() {
      return this.scene === SCENE.ready;
    },
    isSceneError() {
      return this.scene === SCENE.error;
    },
    isScenePlaying() {
      return this.scene === SCENE.playing;
    },
    isSceneExamList() {
      return this.scene === SCENE.examList;
    },
    isFirstExercise() {
      return this.exerciseIndex <= 0;
    },
    isLastExercise() {
      return this.exerciseIndex >= this.exercises.length - 1;
    },
    isBQ() {
      return this.currentExercise.code === 'BQ';
    },
    isDX() {
      return this.currentExercise.code === 'DX';
    },
    isAutoSubmit() {
      return (this.isLearning || this.isPractice || this.isWrongBook)
        && this.results.length;
    },
    isMidwaySave() { // 试卷中途保存
      return this.isExam && !this.isExamRecords && this.results.length;
    },
    isShowExplain() {
      return !this.isLearning;
    },
  },
  watch: {
    currentExercise() {
      if (this.outputAnswer) {
        this.outputAnswer();
      }
    },
    quizData() {
      if (this.isExamRecords) {
        this.score = this.examRecordScore;
        this.reset(SCENE.examList);
        // this.isShowAnswerCard = true;
        this.results = this.initExamUserResult();
      }

      if (this.isBacktrack) {
        utils.confirm('欢迎回来，要继续从上一次退出的地方开始考吗？', '提示', {
          showClose: false,
          closeOnClickModal: false,
        })
          .then(() => {
            this.backtrack();
            this.scene = SCENE.playing;
            this.isShowAnswerCard = true;
          }, () => {
            this.cancelLastTimeLearned();
          });
      }
    },
  },
  methods: {
    ...mapMutations({
      cancelLastTimeLearned: CANCEL_LAST_TIME_LEARNED,
    }),
    ...mapActions({
      submitCourseResult: SUBMIT_COURSE_RESULT,
    }),
    disableCopy() {
      const el = document.querySelector('.hk-dialog');
      el.oncontextmenu = (e) => {
        e.preventDefault();
      };

      el.onselectstart = (e) => {
        e.preventDefault();
      };

      el.oncopy = (e) => {
        e.preventDefault();
      };

      el.onkeydown = e => !(e.ctrlKey || e.ctrlKey || e.shiftKey);
    },
    setAnchor(index) {
      this.$refs.examList.setAnchor(index);
      this.isShowAnswerCard = false;
    },
    examListShow() {
      if (this.isExamRecords) {
        this.$emit('close');
        return;
      }
      this.isShowAnswerCard = true;
    },
    error({ code, message } = {}) {
      this.scene = SCENE.error;

      if (code) {
        this.errorInfo = {
          message,
        };
      } else {
        this.errorInfo = {};
      }
    },
    reset(scene) {
      this.exerciseIndex = 0;
      this.results = [];
      this.isComplete = false;
      this.isShowAnswerCard = false;
      this.scene = scene || SCENE.ready;
    },
    backtrack() {
      this.results = this.exercises.map((exercise) => {
        const answerIndex = utils.Array.findIndex(this.answeredList, exercise, 'id');
        let answer = exercise.code === 'BQ' ? [] : -1;
        let isComplete = false;
        let isRight = false;
        if (answerIndex !== -1) {
          const answered = this.answeredList[answerIndex];
          if (exercise.code === 'BQ') {
            answer = JSON.parse(answered.answer);
            const rightAnswer = exercise.text.match(/(?<=\[\[)[^\]]*(?=]])/g) || [];
            isRight = rightAnswer.every((item, index) => item === answer[index]);
            isComplete = answer.length === rightAnswer.length && answer.every(item => item);
          } else if (exercise.code === 'DX') {
            answer = Number(answered.answer);
            isRight = exercise.answerIndex === answer;
            isComplete = true;
          }
        }
        exercise.userAnswer = answer;
        exercise.isComplete = isComplete;
        exercise.isRight = isRight;
        return {
          answer,
          code: exercise.code,
          id: exercise.id,
          isComplete,
          isRight,
        };
      });
    },
    continueLearning() {
      this.reset();
      this.onContinue();
    },
    onContinue(options = {}) {
      this.$emit('continue', 'DS', options);
    },
    finish({ seconds }) {
      this.scene = SCENE.finished;
      this.$emit('submit', {
        seconds,
        data: this.results.map(answer => ({
          id: answer.id,
          status: Number(answer.isRight),
          errorCount: answer.isRight ? 0 : 1,
          answer: utils.isObject(answer.answer)
            ? JSON.stringify(answer.answer) : answer.answer,
        })),
        callback: () => {
          /* eslint-disable */
          if (this.isReview || this.isWrongBook) return;
          this.onContinue({
            callback: () => {
              if (this.isReview || this.isWrongBook) return;
              this.reset();
            },
          });
        },
      });
    },
    examFinish({ results, seconds }) {
      this.scene = SCENE.finished;
      this.$emit('submit', {
        seconds,
        data: results.map(answer => ({
          id: answer.id,
          status: Number(answer.isRight),
          answer: utils.isObject(answer.answer)
            ? JSON.stringify(answer.answer) : answer.answer,
        })),
        callback: (score) => {
          this.score = score;
          this.scene = SCENE.examList;
          this.isShowAnswerCard = true;
        },
      });
    },
    submitResult(options) {
      this.$emit('submit', {
        seconds: this.$refs.controller.seconds,
        data: this.results.map(answer => ({
          id: answer.id,
          status: Number(answer.isRight),
          errorCount: answer.isRight ? 0 : 1,
          answer: utils.isObject(answer.answer)
            ? JSON.stringify(answer.answer) : answer.answer,
        })),
        ...options,
      });
    },
    updateResult({ results }) {
      this.results = results.filter(result => (result.code === 'BQ' || result.code === 'DX'));
    },
    exerciseChange(index) {
      // when isExam is true 生效
      this.exerciseIndex = index;
    },
    change(payload) {
      this.isComplete = payload.isComplete;
    },
    selectExercise(index) {
      this.$refs.controller.toggleExerciseIndex(index);
      this.isShowAnswerCard = !this.isShowAnswerCard;
    },
    handleSubmitExamBtn() {
      if (!this.results.length) {
        this.$refs.controller.change({});
      }
      this.$nextTick(() => {
        this.$refs.controller.submit();
      });
    },
    detail() {
      this.isShowAnswerCard = !this.isShowAnswerCard;
    },
    prev() {
      if (!this.isExam || this.isFirstExercise) return;
      this.$refs.controller.prev();
    },
    next() {
      /* eslint-disable no-lonely-if */
      if (this.isExam) {
        if (this.isLastExercise) return;
      } else {
        if (this.isDX && !this.currentExercise.isComplete) return;
      }
      this.$refs.controller.next();
      this.$nextTick(() => {
        this.$refs.wrap.scrollTop = 0;
      });
    },
    handleGlobalEnter(event) {
      if (!this.isScenePlaying) return;
      if (this.isShowAnswerCard) return;
      if (event.keyCode === 13) {
        if (this.isBQ && !this.isComplete) return;
        this.next();
      }
    },
    bindEnterEvent() {
      document.addEventListener('keyup', this.handleGlobalEnter);
    },
    unBindEnterEvent() {
      document.removeEventListener('keyup', this.handleGlobalEnter);
    },
    initExamUserResult() {
      /* eslint-disable no-useless-escape */
      return this.exercises.map((item) => {
        let answer = '';
        const isRight = item.wrongAnswer === '';
        if (item.code === 'DX') {
          if (isRight) {
            answer = item.answerIndex;
          } else {
            answer = item.wrongAnswer * 1;
          }
        } else if (item.code === 'BQ') {
          if (isRight) {
            answer = item.text.match(/\[\[[^\[]*\]\]/g)
              .map(strItem => strItem.replace(/^\[\[/g, '').replace(/\]\]$/g, ''));
          } else {
            answer = JSON.parse(item.wrongAnswer);
          }
        }
        return {
          answer,
          code: item.code,
          id: item.id,
          isComplete: true,
          isRight,
        };
      });
    },
    onClose() {
      this.$emit('close');
    },
    handlerFilterResult(isCheckAll) {
      if (!isCheckAll) {
        this.filterResult = this.results.filter(item => !item.isRight);
        this.filterExercises = this.exercises.filter(item => {
          return utils.Array.exist(this.filterResult, item, 'id');
        });
      } else {
        this.filterResult = [];
        this.filterExercises = [];
      }
    },
  },
  created() {
    // if (this.isExamRecords) {
    //   this.score = this.examRecordScore;
    //   this.reset(SCENE.examList);
    //   this.isShowAnswerCard = true;
    //   this.results = this.initExamUserResult();
    // }
    this.bindEnterEvent();
    // if (this.isBacktrack) {
    //   utils.confirm('欢迎回来，要继续从上一次退出的地方开始考吗？', '提示', {
    //     showClose: false,
    //     closeOnClickModal: false,
    //   })
    //     .then(() => {
    //       this.backtrack();
    //       this.scene = SCENE.playing;
    //       this.isShowAnswerCard = true;
    //     }, () => {
    //       this.cancelLastTimeLearned();
    //     });
    // }
  },
  mounted() {
    this.disableCopy();
    this.outputAnswer = utils.debounce(() => {
      let finalAnswer;
      if (this.currentExercise) {
        if (!this.isDX && this.currentExercise.text) {
          finalAnswer = (this.currentExercise.text
            .match(/(\[\[[^\]]*]])/g) || []).map(item => item.replace(/[[|\]]/g, ''));
        } else {
          const { answer } = this.currentExercise;
          finalAnswer = answer;
        }
        /* eslint-disable-next-line */
        if (window['whosyourdaddy']) {
          utils.log(finalAnswer);
        }
      }
    }, 400);
  },
  beforeDestroy() {
    this.unBindEnterEvent();
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .hk-dialog {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .hk-dialog-wrap {
      height: calc(100% - 54px) !important;
      overflow-y: auto;
      .ready, .flex-wrap {
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        h1 {
          padding: 0 20px;
          line-height: 1.8;
        }
        .large {
          font-size: 24px;
        }
        .btn {
          min-width: 120px;
          margin: 0 auto;
        }
        .dialog-logo-wrap {
          img {
            width: 45%;
          }
        }
      }
      .finished {
        height: 100%;
      }
    }
    .exam-detail {
      height: 100%
    }
    .answer-card {
      // height: 100%;
      border-radius: 24px;
      bottom: 65px;
      color: #333;
    }
    .result-answer-card {
      height: 100%;
    }
    .fallible-result {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/aff635725cc02e3a6f0f465aea51cde4.png');
      border-radius: 0 0 24px 24px;
      text-align: center;
      font-size: 20px;
      overflow-y: auto;
      img {
        margin-top: 100px;
        margin-bottom: 24px;
      }
      &__buttons {
        margin-top: 80px;
        &__item {
          display: inline-block;
          width: calc(234px * .75);
          height: calc(68px * .75);
          line-height: calc(68px * .75);
          margin: 0 20px;
          background-size: 100% 100%;
          background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/d5c17aa5e0e28bbf76ebc26fb5fb3333.png');
          cursor: pointer;
          &:nth-child(1) {
            background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/450828b32566d60347c72dfd2c6637bd.png');
          }
          &:active {
            transform: scale(1.05);
          }
        }
      }
    }
    .footer-bar {
      box-sizing: border-box;
      position: absolute;
      bottom: 0;
      padding: 5px 20px;
      width: 100%;
      background: #fff;
    }
  }
</style>
